/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assignee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TasksAssignee from 'DesignSystem/TasksAssignee/index'



/** @type {import('Simple/types.js').View} */
export default function Assignee({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/Assignee",
  onChange
  
}) {
let eventActionDataAssigneeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.assignee',
})
let eventActionDataAssigneeChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.assignee',
})
  return (<React.Fragment
>
<TasksAssignee
  viewPath={`${viewPath}/TasksAssignee`}
 data="event_action.data.assignee"
 assignee_id={eventActionDataAssigneeValueData}
 onChange={eventActionDataAssigneeChangeData}
/>
{children}
</React.Fragment>)
}